var VisaCheckoutBTAuthorization = (function ($, BraintreeAuth) {

	var _ready = new $.Deferred();

	return {
		init: function (options) {
			if (options.enabled) {
                this._braintree = new BraintreeAuth();

                visa_checkout_instance.init(options.visaApiDomain, $.proxy(function () {

                    this._braintree.init();
					this._braintree.onSetupDone($.proxy(function () {
                        this._braintree.visaCheckout.initVisaLiteBox(0, options.authCallback);
					}, this));
                }, this));


			} else {
				// NOTE: it affects checkout too (or can affect... depending on script order)
				$('.v-button').remove();
			}
		}
	};

})(jQuery, BraintreeAuth);